import React from "react";
import styles from "./CustomToaster.module.css";
import checkIcon from "../../../../../assets/Imagess/checkIcon.svg";
import useTimeout from "../useTimeout";
const CustomToaster = ({ text, mode,...props}) => {
  useTimeout(props.close, 1000);
  return (
    <div className={styles["modal-container"]}>
      <div className={styles["modal-backdrop"]}></div>
      <div className={`${styles["modal-innerContainer"]} handle`}>
        <img src={checkIcon} alt='check' />
        <h2>
        {text}
        </h2>
      </div>
    </div>
  );
};

export default CustomToaster;
